module.exports = __webpack_public_path__ + "img/bfefa25.jpg";